// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"TextWithArrowAnimation_textContainer__pYI1F","lightArrow":"TextWithArrowAnimation_lightArrow__rf499","underline":"TextWithArrowAnimation_underline__bEFKM"};